// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c54ca63a","453":"6ed8b0ba","455":"6c494da0","977":"766fa2c1"}[chunkId] + ".chunk.js";
};